import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import { SupervisorsByName } from "../../../../src/components/electeds/supervisors.js";
import * as React from 'react';
export default {
  ElectedInfo,
  SupervisorsByName,
  React
};